<div class="containerTest">
    <div class="text-center">
        <h1>All Admin Users</h1>
    </div>
    <hr>
    <div class="card">
        <div class="card-body" style="overflow-x:auto;">

              <!-- Header -->
              <article class="table-header">
                <!-- Toolbar -->
                <div class="toolbar dt-buttons mb-4">
                    <!-- Invite New Admin -->
                    <button type="button" class="dt-button" [routerLink]="['/admin/invite']">Invite New Admin</button>
                </div>
            </article>

            <!-- Table -->
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="stripe hover row-border order-column">
                <thead>
                    <tr>
                        <th>Email</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Role</th>
                        <th>Registration Date</th>
                        <th>Last Active</th>
                        <th style="min-width:240px">Agency Name</th>
                        <th style="min-width:150px">Agency Street Address 1</th>
                        <th>Agency Street Address 2</th>
                        <th>Agency City</th>
                        <th>Agency State</th>
                        <th>Agency Zip Code</th>
                        <th>Agency County</th>
                        <th>Agency Active</th>
                        <th style="min-width:120px">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let admin of admins; index as i">
                        <td class="text-nowrap">{{ admin.email }}</td>
                        <td>{{ admin.firstName }}</td>
                        <td>{{ admin.lastName }}</td>
                        <td class="text-nowrap">{{ admin.isSuperAdmin ? 'Super Admin' : 'Agency Admin' }}</td>
                        <td class="text-nowrap" [attr.data-sort]="sortDate(admin.registered)">{{ admin.registered | date:'medium' }}</td>
                        <td [attr.data-sort]="sortDate(admin.lastActive)">
                          <ng-container *ngIf="admin.lastActive">
                            <span class="text-nowrap">{{ admin.lastActive | date:'mediumDate' }}</span>,
                            <span class="text-nowrap">{{ admin.lastActive | date:'shortTime' }}</span>
                          </ng-container>
                        </td>
                        <td>{{ admin.agency?.agencyName }}</td>
                        <td>{{ admin.agency?.streetAddress }}</td>
                        <td>{{ admin.agency?.secondary }}</td>
                        <td>{{ admin.agency?.city }}</td>
                        <td>{{ admin.agency?.state }}</td>
                        <td>{{ admin.agency?.zipCode }}</td>
                        <td>{{ admin.agency?.county }}</td>
                        <td class="text-nowrap">{{ admin.agency?.isActive | boolean:'Active':'Not Active' }}</td>
                        <td class="text-nowrap">
                          <button type="button" (click)="editAdminInfo(i)"><mdb-icon fas icon="pen"></mdb-icon></button>
                          <button type="button" *ngIf="admin._id !== user.id" (click)="deleteAdmin(i)" class="btn-danger"><mdb-icon fas icon="trash"></mdb-icon></button>
                          <button type="button" *ngIf="!admin.isSuperAdmin && admin._id !== user.id && admin.agency?.isActive" (click)="loginUnder(admin)" class="btn-warning ml-2">Log In</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
